export default "__VITE_ASSET__a46b37a0__"